import type { IconNode } from '../types';

/**
 * @name mug-teabag
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcgOGgxYTQgNCAwIDEgMSAwIDhoLTEiIC8+CiAgPHBhdGggZD0iTTMgOGgxNHY5YTQgNCAwIDAgMS00IDRIN2E0IDQgMCAwIDEtNC00WiIgLz4KICA8cGF0aCBkPSJNNCA0YTEgMSAwIDAgMSAxLTEgMSAxIDAgMCAwIDEtMSIgLz4KICA8cGF0aCBkPSJNMTAgNGExIDEgMCAwIDEgMS0xIDEgMSAwIDAgMCAxLTEiIC8+CiAgPHBhdGggZD0iTTE2IDRhMSAxIDAgMCAxIDEtMSAxIDEgMCAwIDAgMS0xIiAvPgogIDxwYXRoIGQ9Ik05IDh2MyIgLz4KICA8cGF0aCBkPSJNMTEgMTZ2LTMuNUw5IDExbC0yIDEuNVYxNloiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mug-teabag
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const mugTeabag: IconNode = [
  ['path', { d: 'M17 8h1a4 4 0 1 1 0 8h-1', key: 'jx4kbh' }],
  ['path', { d: 'M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z', key: '1bxrl0' }],
  ['path', { d: 'M4 4a1 1 0 0 1 1-1 1 1 0 0 0 1-1', key: 'fu9hsn' }],
  ['path', { d: 'M10 4a1 1 0 0 1 1-1 1 1 0 0 0 1-1', key: '1w8viq' }],
  ['path', { d: 'M16 4a1 1 0 0 1 1-1 1 1 0 0 0 1-1', key: '1wi25d' }],
  ['path', { d: 'M9 8v3', key: 'ljcm7n' }],
  ['path', { d: 'M11 16v-3.5L9 11l-2 1.5V16Z', key: 'zrpfgk' }],
];

export default mugTeabag;
